"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSelectedClusters = exports.toggleSelectedCluster = void 0;
const SET = "ducks/selectedClusters/SET";
const TOGGLE = "ducks/selectedClusters/TOGGLE";
exports.toggleSelectedCluster = selectedCluster => ({
    type: TOGGLE,
    selectedCluster: selectedCluster
});
exports.setSelectedClusters = selectedClusters => ({
    type: SET,
    selectedClusters: selectedClusters
});
const initialState = [];
function selectedClusters(state = initialState, action) {
    switch (action.type) {
        case SET:
            return action.selectedClusters;
        case TOGGLE:
            var newState = state.slice(0);
            if (newState.includes(action.selectedCluster)) {
                newState.splice(newState.indexOf(action.selectedCluster), 1);
            }
            else {
                newState.push(action.selectedCluster);
            }
            return newState;
        default:
            return state;
    }
}
exports.default = selectedClusters;
